import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

// Site footer for the main Zakat page. Receives `scrollToSection` from the
// parent (since the in-page anchors live there). Keeps its own router
// navigation for the privacy link.
export const ZakatFooter = ({ scrollToSection }) => {
  const navigate = useNavigate();
  return (
    <footer className="gd-anchor bg-[#EDF5F1] text-[#0D1520] py-6 pb-24" data-testid="zakat-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Amanah by Zakat.International" className="h-9 w-9 rounded-full object-cover" />
            <span className="font-heading text-xl font-bold">Amanah by Zakat.International</span>
          </div>
          <p className="text-[#4A5568] text-sm text-center max-w-md">
            This calculator is for guidance only. Please consult a qualified Islamic scholar for specific rulings.
          </p>
          <div className="flex gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => scrollToSection('calculator')}
              className="text-[#0D1520] hover:text-[#0D1520] hover:bg-[#EDF5F1]"
            >
              Calculator
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => scrollToSection('rulings')}
              className="text-[#0D1520] hover:text-[#0D1520] hover:bg-[#EDF5F1]"
            >
              Rulings
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/contact')}
              data-testid="footer-contact-link"
              className="text-[#0D1520] hover:text-[#0D1520] hover:bg-[#EDF5F1]"
            >
              Contact
            </Button>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-[#CBD2D9]">
          <p className="text-[11px] text-[#8B8172] leading-relaxed flex items-center justify-center gap-1.5 text-center flex-wrap">
            <span className="inline-flex items-center gap-1.5">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gold-400">
                <path d="M20 6 9 17l-5-5"/>
              </svg>
              Nothing you enter here leaves your browser. We keep no copy of your calculations, drafts or wills — your data stays on this device.
            </span>
            <button
              type="button"
              onClick={() => navigate('/privacy')}
              data-testid="home-privacy-link"
              className="underline decoration-dotted underline-offset-2 hover:text-[#0D1520] transition-colors"
            >
              Read our privacy note
            </button>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default ZakatFooter;
